module.exports = __webpack_public_path__ + "assets/img/1241587028442_.pic_hd.35755da1.jpg";